import { Grid, Skeleton as MuiSkeleton } from '@mui/material';

export const TimelineSkeleton = ({ count = 5 }: { count?: number }) => {
  return (
    <Grid container spacing={2} m={0}>
      {[...Array(count)].map((_, index) => (
        <Grid key={index} item xs={12} container wrap="nowrap" spacing={2}>
          <Grid item>
            <MuiSkeleton variant="circular" width={25} height={25} />
          </Grid>
          <Grid item xs>
            <MuiSkeleton variant="rectangular" width="90%" height={100} />
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};
